module.exports = __webpack_public_path__ + "img/engine.e4a25d37.svg";